import { ApiUrls } from '@api/apiUrls';
import { fetchApi } from '@api/fetchApi';
import { IPSPInfo } from '@components-member/psp/pspInfo.interface';
import { IAccountApiResponse } from '@components-shared/shared.interfaces';
import { PSP_OPERATION_STATUS } from 'global.enums';
import type { IPlugin, IWallet, InternalTransferInfo } from 'global.interfaces';
import querystring from 'query-string';

export interface IApiPspAdminGridTotals {
  totalAmount: number;
  totalAmountUSD: number;
  totalCount: number;
}

export const apiPspService = {
  getPspPlugins: async (pspType: string) => {
    return await fetchApi.get<{ data?: IPlugin[] } | IPlugin[]>(ApiUrls.psp.getPlugins, {
      params: { type: pspType },
    });
  },
  getPspPluginInfo: async ({ type, pspId }: { type: string; pspId: string | number }) => {
    return await fetchApi.get<IPSPInfo>(`${ApiUrls.psp.getInfo}?${querystring.stringify({ type, pspId })}`);
  },
  getAccounts: async (type: string) => {
    return await fetchApi.get<IAccountApiResponse[]>(ApiUrls.tradingAccountUser.getAllAccounts, {
      params: { type },
    });
  },
  getWalletsAccount: async () => {
    return await fetchApi.get<IWallet[]>(ApiUrls.wallet.getWalletsAccount);
  },
  getInternalTransferInfo: async () => {
    return await fetchApi.get<InternalTransferInfo>(ApiUrls.tradingAccountUser.internalTransferInfo);
  },
  isBeneficiaryBankNameValid: async () => {
    return await fetchApi.get<boolean>(ApiUrls.psp.isBeneficiaryBankNameValid);
  },
  getOperationStatus: async (id: string | number) => {
    return await fetchApi.get<{ status: PSP_OPERATION_STATUS }>(ApiUrls.pspAdmin.get, {
      params: { id },
    });
  },
  getOperationStatusWithStaff: async (id: string | number) => {
    return await fetchApi.get<{ status: PSP_OPERATION_STATUS }>(ApiUrls.pspAdmin.getWithStaff, {
      params: { id },
    });
  },
};
